/* Page de personnalisation d'un design : aperçu en direct, choix du format, ajout au panier.
   Mode « fichier HD » : les calques (texte, décoration) sont dessinés à la taille d'impression, envoyés au relais,
   puis la commande porte leur identifiant. Mode « poster seul » : propriétés de ligne uniquement. */
(function () {
  var root = document.querySelector('[data-hd-designer]');
  if (!root) return;
  var $ = function (n) { return root.querySelector('[data-hd="' + n + '"]'); };
  var cfg; try { cfg = JSON.parse($('config').textContent); } catch (e) { return; }
  /* Liquid échappe les apostrophes en entités HTML : on les décode une fois. */
  var dec = function (s) { var t = document.createElement('textarea'); t.innerHTML = s; return t.value; };
  Object.keys(cfg.t).forEach(function (k) { cfg.t[k] = dec(cfg.t[k]); });
  var T = cfg.t, HD = null, D = null, S = { fmt: null, busy: false, base: null, ready: false };

  var el = { canvas: $('canvas'), formats: $('formats'), dpi: $('dpi'), form: $('form'), prenom: $('prenom'), ville: $('ville'), date: $('date'), heure: $('heure'),
    phrase: $('phrase'), counter: $('counter'), titleToggle: $('title-toggle'), spelling: $('spelling'), consent: $('consent'), add: $('add'), addLabel: $('add-label'), error: $('error'), cropNote: $('crop-note') };

  function money(cents) { return new Intl.NumberFormat(cfg.locale === 'en' ? 'en-GB' : 'fr-FR', { style: 'currency', currency: 'EUR' }).format(Number(cents) / 100); }
  function tpl(s, v) { return String(s || '').replace(/\[(\w+)\]/g, function (_, k) { return v && v[k] != null ? v[k] : ''; }); }
  function track(name, p) { try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, p || {})); if (typeof window.gtag === 'function') window.gtag('event', name, p || {}); } catch (e) {} }
  function showError(msg) { el.error.textContent = msg || ''; el.error.hidden = !msg; }
  function raw() { return { prenom: el.prenom.value, ville: el.ville.value, date: el.date.value, heure: el.heure ? el.heure.value : '', phrase: el.phrase.value }; }
  function variant() { var f = HD.info(cfg.design, S.fmt); return cfg.variants[f.label]; }

  /* ---------- formats ---------- */
  function buildFormats() {
    el.formats.innerHTML = '';
    D.formats.forEach(function (id) {
      var inf = HD.info(cfg.design, id), v = cfg.variants[inf.label];
      if (!v) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'option-button'; b.dataset.id = id; b.disabled = !v.available;
      b.innerHTML = inf.label + '<small>' + money(v.price) + '</small>';
      b.addEventListener('click', function () { selectFormat(id); track('select_format', { format: id }); });
      el.formats.appendChild(b);
    });
  }
  function selectFormat(id) {
    S.fmt = id;
    Array.prototype.forEach.call(el.formats.children, function (b) { b.classList.toggle('active', b.dataset.id === id); });
    var inf = HD.info(cfg.design, id);
    if (cfg.mode && inf.upscaled) { el.dpi.hidden = false; el.dpi.textContent = tpl(T.dpiNote, { dpi: inf.dpiEffective }); } else { el.dpi.hidden = true; }
    var v = variant();
    el.addLabel.textContent = v ? tpl(T.add, { price: money(v.price) }) : T.errVariant;
    el.add.disabled = !v || !v.available;
    render();
  }

  /* ---------- aperçu ---------- */
  var timer = null;
  function render() {
    if (!S.ready || !S.fmt) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var built = HD.build(cfg.design, S.fmt, raw(), 520, { locale: cfg.locale, showTitle: el.titleToggle ? el.titleToggle.checked : true });
      HD.compose(el.canvas, S.base, built);
    }, 40);
  }
  ['prenom', 'ville', 'date', 'heure', 'phrase'].forEach(function (k) {
    if (el[k]) el[k].addEventListener('input', function () { if (k === 'phrase') el.counter.textContent = el.phrase.value.length + '/60'; render(); });
  });
  if (el.titleToggle) el.titleToggle.addEventListener('change', render);

  /* ---------- ajout au panier ---------- */
  function validate() {
    if (!el.prenom.value.trim() || !el.ville.value.trim() || !el.date.value || (el.heure && !el.heure.value)) { showError(T.errForm); return false; }
    if (!el.spelling.checked) { showError(T.errSpelling); return false; }
    if (cfg.mode && !el.consent.checked) { showError(T.errConsent); return false; }
    var v = variant(); if (!v || !v.available) { showError(T.errVariant); return false; }
    if (cfg.mode && !cfg.uploadUrl) { showError(T.errUpload); return false; }
    return true;
  }
  function toBlob(canvas) { return new Promise(function (res) { canvas.toBlob(res, 'image/png'); }); }
  function visibleProps(inf) {
    var r = raw(), p = { 'Support': cfg.mode ? T.supportHd : T.supportPoster, 'Format': inf.label, 'Prénom': r.prenom.trim(), 'Ville': r.ville.trim(), 'Date': r.date };
    if (r.heure) p['Heure'] = r.heure;
    if (r.phrase.trim()) p['Phrase'] = r.phrase.trim();
    if (el.titleToggle) p['Nom de la perle en haut'] = el.titleToggle.checked ? T.titleOn : T.titleOff;
    p['Orthographe vérifiée'] = 'Oui';
    return p;
  }
  function addToCart(props, id) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: props }] }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); track('add_to_cart', { design: cfg.design, format: S.fmt, support: cfg.mode ? 'digital' : 'poster' }); window.location.href = '/cart'; });
  }
  function busy(on, label) { S.busy = on; el.add.disabled = on; if (label) el.addLabel.textContent = label; }

  el.form.addEventListener('submit', function (e) {
    e.preventDefault(); showError('');
    if (S.busy || !validate()) return;
    var v = variant(), inf = HD.info(cfg.design, S.fmt), props = visibleProps(inf);
    var posterProps = { '_support': 'poster_unframed', '_design': cfg.design, '_format': S.fmt };
    /* Poster seul sans relais joignable : la vente passe, la boutique reçoit une alerte « à traiter à la main ». */
    var posterFallback = function () { return addToCart(Object.assign(props, posterProps), v.id).catch(function () { busy(false); selectFormat(S.fmt); showError(T.errUpload); }); };
    if (!cfg.mode && !cfg.uploadUrl) { busy(true, T.busy); posterFallback(); return; }
    busy(true, T.busy);
    var built = HD.build(cfg.design, S.fmt, raw(), inf.W, { locale: cfg.locale, showTitle: el.titleToggle ? el.titleToggle.checked : true });
    var fd = new FormData();
    fd.append('meta', JSON.stringify({ design: cfg.design, format: S.fmt, layers: built.layers.map(function (l) { return { top: l.top, left: l.left, w: l.w, h: l.h, stretch: l.canvas.width !== l.w || l.canvas.height !== l.h }; }) }));
    var chain = Promise.resolve();
    built.layers.forEach(function (l, i) { chain = chain.then(function () { return toBlob(l.canvas); }).then(function (blob) { fd.append('layer' + i, blob, 'layer' + i + '.png'); }); });
    chain.then(function () { busy(true, T.uploading); return fetch(cfg.uploadUrl.replace(/\/$/, '') + '/layers', { method: 'POST', body: fd }); })
      .then(function (r) { if (!r.ok) throw new Error('upload'); return r.json(); })
      .then(function (up) {
        if (!cfg.mode) return addToCart(Object.assign(props, posterProps, { '_hd_layer': up.id }), v.id);
        return addToCart(Object.assign(props, { '_support': 'digital_design', '_design': cfg.design, '_format': S.fmt, '_hd_layer': up.id, '_dpi_effectif': String(inf.dpiEffective), '_renonciation_retractation': 'confirmee' }), v.id);
      })
      .catch(function () { if (!cfg.mode) return posterFallback(); busy(false); selectFormat(S.fmt); showError(T.errUpload); });
  });

  /* ---------- démarrage ---------- */
  function start() {
    HD = window.CelestiarHD; D = HD && HD.DESIGNS[cfg.design];
    if (!D || !window.CELESTIAR_CONFIG) { showError(T.errVariant); return; }
    buildFormats();
    var base = new Image();
    base.onload = function () {
      S.base = base;
      HD.fontsReady(cfg.fonts).catch(function () {}).then(function () {
        S.ready = true;
        var enabled = Array.prototype.filter.call(el.formats.children, function (b) { return !b.disabled; });
        var pick = enabled.filter(function (b) { return b.dataset.id === '30x40'; })[0] || enabled[0];
        if (pick) selectFormat(pick.dataset.id); else showError(T.errVariant);
        if (D.baked && el.cropNote) el.cropNote.textContent = '';
      });
    };
    base.onerror = function () { showError(T.errVariant); };
    base.src = cfg.base;
  }
  if (window.CelestiarHD && window.CELESTIAR_CONFIG) start();
  else window.addEventListener('load', start);
})();
